/* eslint-disable camelcase */
var _window = window,
    _window$bt = _window.bt;
_window$bt = _window$bt === void 0 ? {} : _window$bt;
var _window$bt$product = _window$bt.product;
_window$bt$product = _window$bt$product === void 0 ? {} : _window$bt$product;
var productData = _window$bt$product.data,
    defaultVariantId = _window$bt$product.defaultVariantId,
    defaultSku = _window$bt$product.defaultSku,
    inCart = _window$bt$product.inCart,
    _window$bt$trackers = _window$bt.trackers;
_window$bt$trackers = _window$bt$trackers === void 0 ? {} : _window$bt$trackers;
var _window$bt$trackers$i = _window$bt$trackers.init,
    trackersInit = _window$bt$trackers$i === void 0 ? {} : _window$bt$trackers$i;
var google_tag_params = {
  ecomm_pagetype: trackersInit.pageType,
  dynx_pagetype: trackersInit.pageType
};

if (trackersInit.pageType === 'cart') {
  google_tag_params.ecomm_totalvalue = inCart.total_price / 100.0;
  google_tag_params.ecomm_prodid = defaultVariantId;
} else if (trackersInit.pageType === 'product' || productData) {
  google_tag_params.ecomm_totalvalue = productData.price / 100.0;
  google_tag_params.ecomm_prodid = defaultSku;
}

if (trackersInit.createView) {
  window[window.bt.settings.trackersDataLayer].push({
    action: function action(trackers) {
      if (trackersInit.pageType === 'cart') {
        trackers.event('view-content', {
          contentType: trackersInit.pageType,
          value: inCart.total_price / 100.0,
          currency: 'USD',
          items: inCart.items.map(function (item) {
            return {
              id: item.id,
              title: item.product_title,
              price: item.discounted_price / 100.0,
              quantity: item.quantity
            };
          })
        });
      } else if (trackersInit.pageType === 'category') {
        trackers.event('view-content', {
          contentType: trackersInit.pageType,
          items: [{
            title: trackersInit.collectionTitle || 'ALL PRODUCTS'
          }]
        });
      } else if (trackersInit.pageType === 'product') {
        var value = productData.price / 100.0;
        trackers.event('view-content', {
          contentType: trackersInit.pageType,
          value: value,
          currency: 'USD',
          items: [{
            id: defaultVariantId,
            title: productData.title,
            price: value
          }]
        });
      } else if (trackersInit.pageType === 'searchresults') {
        trackers.event('view-content', {
          contentType: trackersInit.pageType
        });
      } else if (trackersInit.pageType === 'home') {
        trackers.event('view-content', {
          contentType: trackersInit.pageType
        });
      } else {
        trackers.event('view-content', {
          contentType: trackersInit.pageType,
          value: productData && productData.price ? productData.price / 100.0 : 0,
          currency: 'USD',
          items: productData && defaultVariantId && [{
            id: defaultVariantId,
            title: productData.title
          }] || []
        });
      }

      var productImpression = productData && productData || {};
      var productDefaultVariant = defaultVariantId && defaultVariantId || null;
      trackers.view({
        google_tag_params: google_tag_params,
        productImpression: productImpression,
        productDefaultVariant: productDefaultVariant
      });
    }
  });
}